import React, { useState } from 'react';

// โหมดดั้งเดิม (คุมงบ จัดซื้อ)
import { useChefGameLogic } from '../hooks/useChefGameLogic';
import MainMenu from '../components/RegionalChefGame/Screens/MainMenu';
import Tutorial from '../components/RegionalChefGame/Screens/Tutorial';
import GameBoard from '../components/RegionalChefGame/Screens/GameBoard';
import ShopPhase from '../components/RegionalChefGame/Screens/ShopPhase';
import GameOver from '../components/RegionalChefGame/Screens/GameOver';
import KnowledgeBase from '../components/RegionalChefGame/Screens/KnowledgeBase';
import PrepShop from '../components/RegionalChefGame/Screens/PrepShop'; 

// โหมดใหม่ (Balatro Style)
import { useBalatroChef } from '../hooks/useBalatroChef';
import BalatroBoard from '../components/BalatroChef/Board'; // 👈 Import หน้ากระดานใหม่มา

const RegionalChefGamePage = () => {
  const [appScreen, setAppScreen] = useState('MENU');
  const [currentMode, setCurrentMode] = useState('normal'); // จดจำว่าเล่นโหมดอะไรอยู่
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); 
  
  // เรียก Hook ทั้ง 2 เส้นมารอไว้เลย
  const standardGameLogic = useChefGameLogic(); 
  const balatroGameLogic = useBalatroChef();

  // จัดการการเริ่มเกมใหม่
  const handleStartNewGame = (mode) => {
    setCurrentMode(mode);
    
    if (mode === 'balatro') {
      balatroGameLogic.initBalatroGame(); // สั่งรีเซ็ตไพ่ใหม่สำหรับ Balatro
    } else {
      standardGameLogic.initGame(mode); // สั่งรีเซ็ตระบบร้านอาหารสำหรับ Normal/Kids
    }
    
    setAppScreen('GAME');
    setIsSidebarOpen(false);
  };

  const handleNavigate = (screen) => {
    setAppScreen(screen);
    setIsSidebarOpen(false); 
  };

  const renderScreen = () => {
    if (appScreen === 'MENU') return <MainMenu onStartGame={handleStartNewGame} onShowTutorial={() => handleNavigate('TUTORIAL')} onShowKnowledge={() => handleNavigate('KNOWLEDGE')} />;
    if (appScreen === 'TUTORIAL') return <Tutorial onBack={() => handleNavigate('MENU')} />;
    if (appScreen === 'KNOWLEDGE') return <KnowledgeBase onBack={() => handleNavigate('MENU')} />;
    
    if (appScreen === 'GAME') {
      // ⚠️ ถ้าเป็นโหมด Balatro ให้โชว์ Component Board อันใหม่
      if (currentMode === 'balatro') {
        return <BalatroBoard balatroLogic={balatroGameLogic} />;
      }
      
      // ⚠️ ถ้าเป็นโหมด Normal หรือ Kids ให้โชว์ลอจิกร้านค้าแบบเดิม
      const { gameState, day, money, dailyTarget } = standardGameLogic; 
      if (gameState === 'prep_shop') return <PrepShop gameLogic={standardGameLogic} />; 
      if (gameState === 'game_over') return <GameOver day={day} money={money} targetMoney={dailyTarget} />;
      if (gameState === 'shop') return <ShopPhase gameLogic={standardGameLogic} />;
      if (gameState === 'playing') return <GameBoard gameLogic={standardGameLogic} />;
    }
    return null;
  };

  return (
    <div style={{ position: 'relative', minHeight: '100dvh', backgroundColor: '#fdfdfd' }}>
      <button 
        onClick={() => setIsSidebarOpen(true)}
        style={{
          position: 'absolute', top: '15px', left: '15px', zIndex: 1000,
          backgroundColor: 'white', color: '#2f3542', border: '2px solid #dfe4ea',
          borderRadius: '8px', width: '45px', height: '45px', fontSize: '24px',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
        }}
      >
        ☰
      </button>

      {isSidebarOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, transition: 'opacity 0.3s' }} onClick={() => setIsSidebarOpen(false)}>
          <div style={{ width: '280px', height: '100%', backgroundColor: 'white', padding: '20px', boxShadow: '4px 0 15px rgba(0,0,0,0.2)', display: 'flex', flexDirection: 'column' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', borderBottom: '2px solid #f1f2f6', paddingBottom: '15px' }}>
              <h2 style={{ margin: 0, color: '#ff4757' }}>เมนูหลัก</h2>
              <button onClick={() => setIsSidebarOpen(false)} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#a4b0be', cursor: 'pointer' }}>✖</button>
            </div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <li><button onClick={() => handleNavigate('MENU')} style={sidebarButtonStyle}>🏠 หน้าแรก</button></li>
              <li><button onClick={() => handleNavigate('GAME')} style={{...sidebarButtonStyle, backgroundColor: '#e8f8f5', color: '#2ed573', border: '1px solid #2ed573'}}>🎮 กลับเข้าเกม</button></li>
              <li><button onClick={() => handleNavigate('KNOWLEDGE')} style={sidebarButtonStyle}>📚 สาระความรู้อาหาร</button></li>
              <li><button onClick={() => handleNavigate('TUTORIAL')} style={sidebarButtonStyle}>📖 วิธีการเล่น</button></li>
            </ul>
            <div style={{ marginTop: 'auto', textAlign: 'center', color: '#a4b0be', fontSize: '12px' }}>เวอร์ชัน 2.0 (Dual Engine)</div>
          </div>
        </div>
      )}

      {renderScreen()}
    </div>
  );
};

const sidebarButtonStyle = {
  width: '100%', textAlign: 'left', padding: '15px', fontSize: '16px', fontWeight: 'bold', 
  backgroundColor: '#f8f9fa', color: '#2f3542', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.2s'
};

export default RegionalChefGamePage;